export default __webpack_public_path__ + "static/media/Group10.6e1dcd77.svg";